import { DonutChartDataItem } from "../models/core/chart-interfaces";
import { generateEmptyAgeChartItems } from "../utils/demographics-chart.helper";

export const EMPTY_GENDER_CHART_ITEMS: DonutChartDataItem[] = [
    { type: 'female', value: 0, percentage: 0, color: '#E794F8' },
    { type: 'male', value: 0, percentage: 0, color: '#5AC8FF' },
    { type: 'other', value: 0, percentage: 0, color: '#FFA500' },
];

export const EMPTY_AGE_CHART_ITEMS = generateEmptyAgeChartItems();
